import { useEffect } from "react";
import { gsap } from "gsap";

interface PulseAnimationProps {
    svgElement: SVGElement;
    animationSpeed: number;
  }
const PulseAnimation: React.FC<PulseAnimationProps> = ({ svgElement, animationSpeed }) => {
  useEffect(() => {
    const elements = svgElement.querySelectorAll("circle, rect");

    gsap.to(svgElement, {
      scale: 1.2,
      duration: animationSpeed,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut",
    });
  }, [svgElement, animationSpeed]);

  return null;
};

export default PulseAnimation;
